import { Outlet, ScrollRestoration } from 'react-router';

import { useHeartbeat } from '~/api/application';
import { env } from '~/constants/env';

import { rootStyle } from './Root.css';
import { useForceRefresh } from './Root.hooks';
import { RootCommandMenuItems } from './RootCommandMenuItems';

export const Root = () => {
  const heartbeat = useHeartbeat();

  useForceRefresh(heartbeat.apiVersion);

  return (
    <>
      <div className={rootStyle}>
        <Outlet />
      </div>

      <ScrollRestoration />

      {(env.IS_LOCAL_DEV_ENV || env.IS_STAGING_ENV) && <RootCommandMenuItems />}
    </>
  );
};
